import { render } from "./QuizAnswerList.vue?vue&type=template&id=33e00101"
import script from "./QuizAnswerList.vue?vue&type=script&lang=js"
export * from "./QuizAnswerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__